import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { User, ChevronRight, Briefcase, Download } from "lucide-react";
import { api, rm, STATUS, timeMY } from "@/lib/api";
import { useCart } from "@/lib/cart";

function useInstall() {
  const [evt, setEvt] = useState(null);
  useEffect(() => {
    const h = (e) => { e.preventDefault(); setEvt(e); };
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);
  return evt;
}

export default function Account() {
  const { profile, setProfile, history } = useCart();
  const [orders, setOrders] = useState([]);
  const install = useInstall();

  useEffect(() => {
    Promise.all(history.map((id) => api.get(`/orders/${id}`).then((r) => r.data).catch(() => null))).then((r) => setOrders(r.filter(Boolean)));
  }, [history]);

  return (
    <div>
      <div className="bg-[#B91C1C] text-white px-5 pt-10 pb-8 rounded-b-[28px]">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-white/15 flex items-center justify-center"><User className="w-8 h-8" /></div>
          <div>
            <h1 className="font-display text-xl font-bold" data-testid="account-name">{profile.name || "Pelanggan"}</h1>
            <p className="text-sm text-white/80">{profile.phone || "Tiada no. telefon"}</p>
          </div>
        </div>
      </div>
      <div className="px-5 py-6 space-y-6">
        <section className="bg-white rounded-2xl border p-4 space-y-3">
          <h2 className="font-display font-bold">Maklumat Saya</h2>
          <input value={profile.name} onChange={(e) => setProfile({ ...profile, name: e.target.value })} data-testid="account-name-input" placeholder="Nama" className="w-full h-11 px-3 rounded-xl border text-sm outline-none focus:ring-2 focus:ring-[#B91C1C]" />
          <input value={profile.phone} onChange={(e) => setProfile({ ...profile, phone: e.target.value })} data-testid="account-phone-input" placeholder="No. Telefon (WhatsApp)" className="w-full h-11 px-3 rounded-xl border text-sm outline-none focus:ring-2 focus:ring-[#B91C1C]" />
        </section>
        <section>
          <h2 className="font-display font-bold mb-3">Sejarah Pesanan</h2>
          {orders.length === 0 && <p className="text-sm text-slate-500" data-testid="history-empty">Belum ada pesanan.</p>}
          <div className="space-y-3">
            {orders.map((o) => (
              <Link key={o.id} to={`/pesanan/${o.id}`} data-testid={`history-${o.order_no}`} className="flex items-center gap-3 bg-white rounded-2xl border p-4 hover:border-[#B91C1C] transition-colors">
                <div className="flex-1">
                  <p className="font-bold text-sm">#{o.order_no}</p>
                  <p className="text-xs text-slate-500">{new Date(o.created_at).toLocaleDateString("ms-MY")} · {timeMY(o.created_at)} · {rm(o.total)}</p>
                </div>
                <span className={`px-2.5 py-1 rounded-full text-[11px] font-semibold ${STATUS[o.status].cls}`}>{STATUS[o.status].label}</span>
                <ChevronRight className="w-4 h-4 text-slate-400" />
              </Link>
            ))}
          </div>
        </section>
        {install && (
          <button onClick={() => install.prompt()} data-testid="install-app-button" className="w-full h-12 rounded-xl border border-[#B91C1C] text-[#B91C1C] font-semibold flex items-center justify-center gap-2">
            <Download className="w-4 h-4" /> Pasang App di Telefon
          </button>
        )}
        <Link to="/panel" data-testid="staff-login-link" className="flex items-center gap-3 text-sm text-slate-600 py-2">
          <Briefcase className="w-4 h-4" /> Log Masuk Pekerja <ChevronRight className="w-4 h-4 ml-auto" />
        </Link>
      </div>
    </div>
  );
}
